module.exports = __webpack_public_path__ + "img/AW.fcd7c184.svg";